import { Modal, noop } from '@panwds/react-ui';
import { classNames } from '@panwds/tailwindcss';
import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
/**
 * Renders a form and wraps the children in a FormProvider. All extra props will be passed to `useForm` from react-hook-form.
 */
export function Form(props) {
    const { children, dataMetrics, dataTestId, focusOnMount, modalProps, formProps = {}, onSubmit = noop, onError = noop, ...rest } = props;
    const formMethods = useForm(rest);
    const { formState: { dirtyFields } } = formMethods;
    const isDirty = Object.keys(dirtyFields).length > 0;
    useEffect(() => {
        if (focusOnMount) {
            try {
                formMethods.setFocus(focusOnMount);
            }
            catch (_e) /* istanbul ignore next */ {
                const error = `Failed to focus on field ${focusOnMount} after mounting form`;
                console.error(error);
            }
        }
    }, []);
    const body = (React.createElement(FormProvider, { ...formMethods },
        React.createElement("form", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'form', className: classNames(modalProps &&
                'tw-flex tw-flex-col tw-flex-auto tw-overflow-auto tw-scrollbar-default dark:tw-scrollbar-track-dark dark:tw-scrollbar-thumb-dark dark:tw-scrollbar-corner-dark'), onSubmit: formMethods.handleSubmit(onSubmit, onError), ...formProps }, children)));
    if (modalProps) {
        return (React.createElement(Modal, { confirmClose: isDirty, ...modalProps }, body));
    }
    return body;
}
//# sourceMappingURL=Form.js.map